import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import useCurrency from '../hooks/useCurrency'
import useCryptoCurrency from '../hooks/useCryptoCurrency'
import Error from '../components/Error'
import axios from 'axios';
import PropTypes from 'prop-types';

/**Styles */
const Button = styled.input`
    margin-top:20px;
    font-weight:bold;
    font-size:20px;
    padding:10px;
    background-color:#66a2fe;
    border:none;
    width:100%;
    border-radius:10px;
    color:#FFF;
    transition:background-color .3s ease;

    &:hover {
        background-color:#326ac0;
        cursor:pointer;
    }
`;
/**Component */
const Form = ({saveCurrency,saveCryptoCurrency}) => {

    /**Validation */
    const [error, hasError] = useState(false);

    const [cryptoCurrencies, setCryptoCurrencies] = useState([]);


    const CURRENCIES = [
        { code: 'USD', name: 'Dolar de Estados unidos' },
        { code: 'MXN', name: 'Peso Mexicano' },
        { code: 'EUR', name: 'Euro' },
        { code: 'GBP', name: 'Libra esterlina' },
        { code: 'CLP', name: 'Peso chileno' }
    ]

    // Utilizar useCurrency
    const [currency, SelectCurrency] = useCurrency('Elige tu moneda', '', CURRENCIES);
    // Utilizar useCryptoCurrency
    const [cryptoCurrency, SelectCryptoCurrency] = useCryptoCurrency('Elige tu criptomoneda', '', cryptoCurrencies);

    //Ejecutar llamado a la api 
    // cuando  el documento este listo con useEffect
    useEffect(() => {
        const consultAPI = async () => {
            const url = 'https://min-api.cryptocompare.com/data/top/mktcapfull?limit=10&tsym=USD';
            const result = await axios.get(url);

            setCryptoCurrencies(result.data.Data);
        }
        consultAPI();
    }, [])

    const quoteCurrency = (e) => {
        e.preventDefault();
        if (currency === '' || cryptoCurrency === '') {
            hasError(true);
            return;
        }
        hasError(false);
        saveCurrency(currency);
        saveCryptoCurrency(cryptoCurrency);
    }

    return (
        <form
            onSubmit={quoteCurrency}
        >

            {/* Validation */}
            {error ? 
                <Error
                    message={"Todos los campos son obligatorios"}
                /> : null
            }


            <SelectCurrency
            />
            <SelectCryptoCurrency
            />
            <Button
                type="submit"
                value="Calcular"
            />
        </form>
    );
}
Form.propTypes = {
    saveCurrency:PropTypes.func.isRequired,
    saveCryptoCurrency:PropTypes.func.isRequired
}
export default Form;